var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"deny-dialog\" layout=\"column\">\n<form name=\"vm.denyMessageForm\">\n<div layout=\"row\" layout-align=\"space-between start\">\n<h3 translate=\"yes\">Send Deny Request Email</h3>\n<div>\n<md-button class=\"md-primary\" ng-click=\"vm.onCancel()\">\n<span translate=\"yes\">Cancel</span>\n</md-button>\n<md-button class=\"md-raised md-primary md-hue-2\" ng-click=\"vm.onSend()\" ng-disabled=\"vm.denyMessageForm.$invalid\">\n<span translate=\"yes\">Send</span>\n</md-button>\n</div>\n</div>\n<div>\n<md-input-container class=\"md-block\">\n<label>Reason for Account Request Denial:</label>\n<textarea ng-model=\"vm.email\" md-maxlength=\"300\" rows=\"5\" md-select-on-focus required></textarea>\n</md-input-container>\n</div>\n</form>\n</div>";
var id1="admin/pending-approval/deny-message-dialog.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/admin/pending-approval/deny-message-dialog.html
// module id = 619
// module chunks = 0